"use strict";

exports.__esModule = true;
exports["default"] = exports.MappedSlideIn = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _ramda = require("ramda");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

var _moreButton = _interopRequireDefault(require("../more-button"));

var _utils = require("../../utils");

var _nestedCheckboxFilters = _interopRequireDefault(require("./nested-checkbox-filters"));

var _excluded = ["children", "in", "isOpen"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var mappedSlideInpropTypes = {
  children: _propTypes.node,
  "in": _propTypes.bool,
  isOpen: _propTypes.bool
};

var MappedSlideIn = function MappedSlideIn(_ref) {
  var children = _ref.children,
      animateIn = _ref["in"],
      isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_animations.SlideIn, _extends({}, props, {
    animateIn: animateIn,
    show: isOpen
  }), children);
};

exports.MappedSlideIn = MappedSlideIn;
MappedSlideIn.propTypes = mappedSlideInpropTypes;
var checkFontObject = {
  color: "body-grey",
  fontSize: [2, 2, 1],
  letterSpacing: [0, 0, "0.5px"],
  lineHeight: 2
};
var propTypes = {
  /** Object map of filters currently active */
  activeFilters: (0, _propTypes.objectOf)(_propTypes.bool),
  // Object map of filters currently disabled
  disabledFilters: (0, _propTypes.objectOf)(_propTypes.bool),

  /** onChange event handler - used to process the filter selection event */
  filterOnChange: _propTypes.func,
  // Determines MoreButton isExpanded prop
  isExpanded: _propTypes.bool,
  // Determines show/hide of animations
  isOpen: _propTypes.bool,
  // Determines show/hide more button
  showMoreButton: _propTypes.bool,
  // Callback to handle more button click event
  showMoreOnClick: _propTypes.func,
  // Object map of all filters active
  visibleFilters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }))
}; // https://github.com/reactjs/react-transition-group/issues/170
// The react-transition-group props automatically get passed to the first child component

var AccordianItemContainer = function AccordianItemContainer(_ref2) {
  var props = Object.assign({}, _ref2);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({}, (0, _ramda.omit)(["onExited", "in"], props), {
    width: 1
  }));
};

var AccordionItems = function AccordionItems(_ref3) {
  var activeFilters = _ref3.activeFilters,
      disabledFilters = _ref3.disabledFilters,
      filterOnChange = _ref3.filterOnChange,
      isExpanded = _ref3.isExpanded,
      isOpen = _ref3.isOpen,
      showMoreButton = _ref3.showMoreButton,
      showMoreOnClick = _ref3.showMoreOnClick,
      visibleFilters = _ref3.visibleFilters;
  return /*#__PURE__*/_react["default"].createElement(_animations.TransitionGroup, null, /*#__PURE__*/_react["default"].createElement(AccordianItemContainer, null, (0, _utils.mapIndexed)(function (filter, index) {
    return /*#__PURE__*/_react["default"].createElement(MappedSlideIn, {
      key: filter.id,
      alwaysShowInDom: false,
      delayIn: index * 0.04,
      delayOut: (visibleFilters.length - index) * 0.04,
      enterDuration: 0.25,
      exitDuration: 0.25,
      fadeInOut: true,
      isOpen: isOpen,
      vertical: -0.5
    }, !(filter.chidren && filter.chidren.length) ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
      py: [0, 2, 1]
    }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      checkboxOnChange: function checkboxOnChange(event) {
        return filterOnChange(Object.assign({
          event: event
        }, filter));
      },
      checkBoxWidth: [20, 20, 16],
      checkFontObject: checkFontObject,
      disabled: disabledFilters[filter.value],
      flexDirection: ["row-reverse", "row-reverse", "row"],
      isChecked: activeFilters[filter.value],
      justifyContent: ["space-between", "space-between", "flex-start"],
      label: filter.label,
      mr: [0, 0, 1],
      py: ["15px", 0, 0],
      value: filter.value,
      width: 1
    })) : /*#__PURE__*/_react["default"].createElement(_nestedCheckboxFilters["default"], {
      activeFilters: activeFilters,
      checkFontObject: checkFontObject,
      disabledFilters: disabledFilters,
      filterOnChange: filterOnChange,
      parentFilter: filter
    }));
  }, visibleFilters), showMoreButton ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mb: [3, 3, 1],
    mt: [0, 0, 1],
    pl: [0, 0, 3]
  }, /*#__PURE__*/_react["default"].createElement(_animations.SlideIn, {
    alwaysShowInDom: true,
    delayIn: visibleFilters.length * 0.04,
    fadeInOut: true,
    show: isOpen,
    vertical: -1
  }, /*#__PURE__*/_react["default"].createElement(_moreButton["default"], {
    isExpanded: isExpanded,
    toggleIsExpanded: showMoreOnClick
  }))) : null));
};

AccordionItems.propTypes = propTypes;
AccordionItems.displayName = "Modules.AccordionItems";
var _default = AccordionItems;
exports["default"] = _default;